export default __webpack_public_path__ + "/dist/images/buyer-contentimg.fafdf07407ade905ae81c0b5059470f7.png";